export function isEncodeable(object) {
    if (typeof object !== "object" || object === null) {
        return false;
    }
    return !!object.encode;
}
/**
 * Use this method to encode an object (might be an encodeable implementation) into a decodable structure
 */
export function encodeObject(obj, context) {
    if (isEncodeable(obj)) {
        return obj.encode(context);
    }
    if (Array.isArray(obj)) {
        return obj.map((e) => {
            return encodeObject(e, context);
        });
    }
    if (obj instanceof Map) {
        // Transform into a normal object to conform to MapDecoders expected format
        const encodedObj = {};
        for (const [key, value] of obj) {
            const k = encodeObject(key, context);
            encodedObj[k] = encodeObject(value, context);
        }
        return encodedObj;
    }
    // Failed to decode
    return obj;
}
//# sourceMappingURL=Encodeable.js.map